/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UnappliedBy/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function UnappliedBy({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/Expanded/Content/Content/Entry/EntryType/AppliedPayment/Content/UnappliedBy"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let entryTransactionAppliedPaymentUnappliedPaymentValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'transaction.applied_payment.unapplied_payment',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(entryTransactionAppliedPaymentUnappliedPaymentValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}